module.exports = __webpack_public_path__ + "KaTeX_Size3-Regular.d44de352.woff2";